import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Nftpropertymodal from './Nftpropertymodal';
import AddIcon from '@mui/icons-material/Add';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ property ,setProperty }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
 
    return (
        <div>
            <Box className='special_offers' width='98%'>
                <Button onClick={handleOpen}> <AddIcon /> Add</Button>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={{ ...style, width: { xs: '70%', xl: '50%' } }} className='special_offers'>
                       <Nftpropertymodal property={property} setProperty={setProperty} handleClose={handleClose}/>
                    </Box>
                </Modal>
            </Box>
        </div>
    );
} 